import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import { cn } from '@core/utils';
import type { UnauthApi } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { readTappedThumbnail } from '@/app/_components/entryPreview';
import { Image } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { formatPrice } from '@/utils/formatPrice';
import { rememberCampaignPreview } from '../_utils/campaignPreview';
import { formatCampaignMonthDay, formatCampaignTime, formatRemainingDays } from '../_utils/formatCampaignDate';
export type CampaignListItem = NonNullable<NonNullable<Awaited<ReturnType<(typeof UnauthApi)['get:/wello/v2/allows/gift-trial/campaigns']>>['data']>['context']>['contents'][number];
interface CampaignCardProps {
  campaign: CampaignListItem;
}
export const CampaignCard = t0 => {
  const $ = _c(58);
  const {
    campaign
  } = t0;
  const isRecruiting = campaign.campaignPhase === "RECRUITING";
  let t1;
  bb0: {
    if (isRecruiting) {
      t1 = null;
      break bb0;
    }
    if (campaign.campaignPhase === "UPCOMING") {
      let t2;
      if ($[0] !== campaign.applyStartAt) {
        t2 = formatCampaignMonthDay(campaign.applyStartAt);
        $[0] = campaign.applyStartAt;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      let t3;
      if ($[2] !== campaign.applyStartAt) {
        t3 = formatCampaignTime(campaign.applyStartAt);
        $[2] = campaign.applyStartAt;
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      t1 = `${t2}\n${t3} 오픈 예정`;
      break bb0;
    }
    t1 = "\uC885\uB8CC";
  }
  const thumbnailCover = t1;
  let t2;
  if ($[4] !== campaign.campaignId) {
    t2 = DONATION_ROUTES.GIFT_TRIAL_DETAIL.withSearchParams({
      dynamicPath: {
        campaignId: campaign.campaignId
      }
    });
    $[4] = campaign.campaignId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== campaign.campaignId || $[7] !== campaign.institutionName || $[8] !== campaign.marketPrice || $[9] !== campaign.thumbnailUrl || $[10] !== campaign.trialProductName) {
    t3 = event => {
      rememberCampaignPreview({
        campaignId: campaign.campaignId,
        mainImageUrl: campaign.thumbnailUrl,
        thumbnailSrc: readTappedThumbnail(event.currentTarget),
        productName: campaign.trialProductName,
        institutionName: campaign.institutionName,
        marketPrice: campaign.marketPrice
      });
    };
    $[6] = campaign.campaignId;
    $[7] = campaign.institutionName;
    $[8] = campaign.marketPrice;
    $[9] = campaign.thumbnailUrl;
    $[10] = campaign.trialProductName;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("group flex items-center gap-16 rounded-small", "mobile-tablet:flex-col mobile-tablet:items-stretch mobile-tablet:gap-12", FOCUS_RING);
    t5 = cn("relative size-160 shrink-0 overflow-hidden rounded-small border border-Gray-black/5 bg-Gray-black/10", "mobile-tablet:aspect-square mobile-tablet:size-auto mobile-tablet:rounded-large");
    $[12] = t4;
    $[13] = t5;
  } else {
    t4 = $[12];
    t5 = $[13];
  }
  let t6;
  if ($[14] !== campaign.thumbnailUrl || $[15] !== campaign.trialProductName) {
    t6 = <Image src={campaign.thumbnailUrl} alt={campaign.trialProductName} fill={true} sizes="(max-width: 1279px) 272px, 160px" className="object-cover transition-opacity duration-150 group-hover:opacity-80 group-active:opacity-80 motion-reduce:transition-none" />;
    $[14] = campaign.thumbnailUrl;
    $[15] = campaign.trialProductName;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== campaign.actualApplyEndAt || $[18] !== isRecruiting) {
    t7 = isRecruiting ? <Badge className="absolute left-10 top-10 bg-O-400 text-Gray-white">{formatRemainingDays(campaign.actualApplyEndAt)}</Badge> : null;
    $[17] = campaign.actualApplyEndAt;
    $[18] = isRecruiting;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== thumbnailCover) {
    t8 = thumbnailCover ? <p className="absolute inset-0 whitespace-pre-line bg-Gray-black/50 text-center font-600 text-Gray-white flex-center typo-body2">{thumbnailCover}</p> : null;
    $[20] = thumbnailCover;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t6 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = cn("flex min-w-0 flex-1 flex-col gap-16", "mobile-tablet:gap-4");
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== campaign.institutionName) {
    t11 = <span className="flex items-center gap-4 font-600 text-Gray-600 typo-caption1"><span className="truncate">{campaign.institutionName}</span></span>;
    $[27] = campaign.institutionName;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = cn("line-clamp-1 font-500 text-Gray-900 typo-body4 group-hover:underline", "mobile-tablet:line-clamp-2");
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== campaign.trialProductName) {
    t13 = <span className={t12}>{campaign.trialProductName}</span>;
    $[30] = campaign.trialProductName;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t11 || $[33] !== t13) {
    t14 = <div className="flex flex-col gap-4">{t11}{t13}</div>;
    $[32] = t11;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = cn("flex flex-wrap items-center gap-4", "mobile-tablet:flex-col mobile-tablet:items-start mobile-tablet:gap-0");
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== campaign.marketPrice) {
    t16 = formatPrice(campaign.marketPrice);
    $[36] = campaign.marketPrice;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t16) {
    t17 = <span className="font-500 text-Gray-700 typo-caption1">시중가 <del>{t16}</del></span>;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="flex items-center gap-4 text-O-400"><span className="font-600 typo-caption1">체험단 선정 시</span><strong className="font-700 typo-body3">0원</strong></span>;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t17) {
    t19 = <div className="flex flex-col"><div className={t15}>{t17}{t18}</div></div>;
    $[41] = t17;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== campaign.actualApplyEndAt || $[44] !== campaign.recruitCount || $[45] !== isRecruiting) {
    t20 = isRecruiting ? <span className="font-500 text-Gray-black typo-caption1">{campaign.recruitCount}명 모집중 ·{" "}{formatCampaignMonthDay(campaign.actualApplyEndAt)} 마감</span> : null;
    $[43] = campaign.actualApplyEndAt;
    $[44] = campaign.recruitCount;
    $[45] = isRecruiting;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t19 || $[48] !== t20) {
    t21 = <div className="flex flex-col gap-4">{t19}{t20}</div>;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t14 || $[51] !== t21) {
    t22 = <div className={t10}>{t14}{t21}</div>;
    $[50] = t14;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== t2 || $[54] !== t22 || $[55] !== t3 || $[56] !== t9) {
    t23 = <CustomLink href={t2} prefetch={false} onClick={t3} className={t4}>{t9}{t22}</CustomLink>;
    $[53] = t2;
    $[54] = t22;
    $[55] = t3;
    $[56] = t9;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  return t23;
};